<template>
  <b-card title="Disabilitas">
    <!-- chart -->
    <chartjs-component-doughnut-chart
      :height="275"
      :data="chartjsData.doughnutChart2.data"
      :options="chartjsData.doughnutChart2.options"
      class="mb-3"
    />
    <!--/ chart -->

    <!-- stocks -->
    <div
      v-for="(stock,index) in stockData"
      :key="stock.device"
      :class="index < stockData.length-1 ? 'mb-1':''"
      class="d-flex justify-content-between"
    >
      <div class="d-flex align-items-center">
        <feather-icon
          :icon="stock.symbol"
          size="16"
          :class="stock.color"
        />
        <span class="font-weight-bold ml-75 mr-25">{{ stock.device }}</span>
        <span>- {{ stock.percentage }}</span>
      </div>
      <div>
        <span>{{ stock.upDown }}%</span>
        <!-- <feather-icon
          :icon="stock.upDown > 0 ? 'ArrowUpIcon':'ArrowDownIcon'"
          :class="stock.upDown > 0 ? 'text-success':'text-danger'"
        /> -->
      </div>
    </div>
    <!--/ stocks -->
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ChartjsComponentDoughnutChart from './charts-components/ChartjsComponentDoughnutChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    ChartjsComponentDoughnutChart,
    BCard,
  },
  data() {
    return {
      chartjsData,
      stockData: [
        {
          device: 'Total User Terdaftar', symbol: 'UsersIcon', color: 'text-primary', percentage: 1490, upDown: 100,
        },
        {
          device: 'Disabilitas', symbol: 'WindIcon', color: 'text-primary', percentage: 149, upDown: 10,
        },
        {
          device: 'Non Disablitas', symbol: 'ZapIcon', color: 'text-warning', percentage: 1341, upDown: 90,
        },
      ],
    }
  },
}
</script>
